import { NgToggleConfig } from 'ng-toggle-button';

export default {
  color: {
    checked: '#406464',
    unchecked: '#E4F2F5'
  },
  margin: 3,
  fontColor: 'orange',
  switchColor: 'white',
  width: 40,
  height: 24
} as NgToggleConfig;
